var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CardDashboardSmall_1;
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Image } from '@philips-internal/oswald-ui-components/lib/components';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ReactComponent as CancelSVG } from '../../assets/images/icons/cancel.svg';
import { ReactComponent as CheckSVG } from '../../assets/images/icons/check.svg';
import consultation from '../../assets/images/global/consultation.svg';
import calendar from '../../assets/images/global/calendar.svg';
import locale from '../../assets/images/global/locale.svg';
import exams from '../../assets/images/global/exams.svg';
import avatarPhysician from '../../assets/images/avatars/avatar-phys.svg';
import avatarService from '../../assets/images/global/avatar-service.svg';
import './card-dashboard-small.css';
import moment from 'moment/moment.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
let CardDashboardSmall = CardDashboardSmall_1 = class CardDashboardSmall extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            fullMode: true,
            visible: true,
            width: 12
        };
    }
    static { this.propTypes = {
        dsEnderecoEstab: string,
        dsFoto: string,
        dsStatus: string,
        dsSubTitulo: string,
        dsTitulo: string,
        dsTypeSchedule: string,
        dtAgendamento: string,
        hrAgendamento: string,
        ieScheduleType: string,
        ieStatus: number,
        onClick: eventListener,
    }; }
    static { this.ScheduleType = {
        CHEMOTHERAPY: 'Q',
        CONSULTATION: 'C',
        EXAM: 'E',
        SERVICE: 'S',
        SURGERY: 'Y',
    }; }
    getIcon(ieScheduleType) {
        switch (ieScheduleType) {
            case CardDashboardSmall_1.ScheduleType.EXAM: return exams;
            case CardDashboardSmall_1.ScheduleType.SERVICE: return avatarService;
            case CardDashboardSmall_1.ScheduleType.SURGERY:
            case CardDashboardSmall_1.ScheduleType.CHEMOTHERAPY: return avatarPhysician;
            default: return consultation;
        }
    }
    render() {
        const { onClick, dsEnderecoEstab, ieScheduleType, dsFoto, dsStatus, dsTitulo, dsTypeSchedule, dsSubTitulo, dtAgendamento, hrAgendamento } = this.props;
        let title = dsTitulo;
        if (title && title.length > 15) {
            title = `${title.substr(0, 16)}...`;
        }
        moment.updateLocale('en', {
            calendar: {
                lastDay: '[Yesterday]',
                lastWeek: '[Last Week]',
                nextDay: '[Tomorrow]',
                nextWeek: '[Next Week]',
                sameDay: '[Today]',
                sameElse: 'L'
            }
        });
        const consultationDate = moment(dtAgendamento, 'YYYYMMDD').calendar();
        const icon = this.getIcon(ieScheduleType);
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-appointments', onClick: trigger(onClick, new ClickEvent()), selectionType: SelectionType.NONE, transparent: false },
            React.createElement("div", { className: `c-patient-term-card__wrapper c-patient-term-card__border-${this.getColor()}` },
                React.createElement("div", { className: 'content-right' },
                    React.createElement("div", { className: 'consultation-date' },
                        React.createElement("output", null, consultationDate)),
                    React.createElement("div", { className: 'status' },
                        dsStatus,
                        this.getSvg())),
                React.createElement("div", { className: 'content-inner' },
                    React.createElement("div", { className: 'content-left' },
                        React.createElement(Avatar, { image: dsFoto ? 'data:image/png;base64,' + dsFoto : icon }),
                        React.createElement("div", { className: 'content-left-texts' },
                            React.createElement("output", null,
                                React.createElement("b", null, title)),
                            React.createElement("div", { className: 'content-left-texts-sub' },
                                React.createElement("output", null,
                                    dsTypeSchedule,
                                    " | ",
                                    dsSubTitulo)))),
                    React.createElement("div", { className: 'content-date-local' },
                        React.createElement(Image, { src: calendar, className: 'icon-size', alt: '' }),
                        React.createElement("div", { className: 'content-left-texts-sub' },
                            React.createElement("output", null,
                                ModelService.format('date', dtAgendamento),
                                " - ",
                                hrAgendamento))),
                    React.createElement("div", { className: 'content-date-local' },
                        React.createElement(Image, { src: locale, className: 'icon-size', alt: '' }),
                        React.createElement("div", { className: 'content-left-texts-sub' },
                            React.createElement("output", null, dsEnderecoEstab)))))));
    }
    getColor() {
        const { dsStatus } = this.props;
        switch (dsStatus) {
            case 'Canceled':
                return 'red';
            default:
                return 'green';
        }
    }
    getSvg() {
        const { dsStatus } = this.props;
        switch (dsStatus) {
            case 'Canceled':
                return React.createElement(CancelSVG, { size: 18, className: `c-patient-term-card__color-${this.getColor()}` });
            default:
                return React.createElement(CheckSVG, { size: 18, className: `c-patient-term-card__color-${this.getColor()}` });
        }
    }
};
CardDashboardSmall = CardDashboardSmall_1 = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardDashboardSmall);
export default CardDashboardSmall;
//# sourceMappingURL=card-dashboard-small.js.map